<header>
  <div class="crumb">
    <a data-icon="petition" class="icon-before" routerLink="../../">Petitions</a>
    @if (petitions?.length) {
      <span>{{ petitions[0].topic.name }}</span>
    }
  </div>

  <div>
    <div class="filters">
      @for (status of statuses; track status) {
        <button
          [class.neutral]="status != selectedStatus"
          [disabled]="status == selectedStatus"
          (click)="filterPetitions(status)">
          {{ status }}
        </button>
      }
    </div>

    @if (user?.staff) {
      <a role="button" class="colored" routerLink="/campaigns/new">
        <mat-icon>add</mat-icon>
        New
      </a>
    }
  </div>
</header>

<div class="petition-list">
  @for (petition of petitions; track petition) {
    <tyt-petition-card [petition]="petition" [image]="true"></tyt-petition-card>
  }
</div>
